import { ControllerPaletteColor } from './__palette-color';

export enum ControllerChartColor {
  BorderColor = ControllerPaletteColor.Gray600,
  BorderColorLight = ControllerPaletteColor.Gray800,
  LabelColorFg = ControllerPaletteColor.Gray200,
  TooltipColorBg = ControllerPaletteColor.Gray200,
  TooltipColorFg = ControllerPaletteColor.GrayWhite,
}

export enum ControllerLineChartColor {
  LineSeriesAreaFillOpacity = 0.15,
  LineSeries1ColorFg = ControllerPaletteColor.Ngb500,
  PointSeries1ColorFg = ControllerPaletteColor.Ngb400,
}
